<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    Message Cart
    <i class="fa fa-times-circle pull-right" aria-hidden="true" (click)="closeDialog($event)"></i>
  </div>
</div>

<div mat-dialog-content class="m-0">
    <div class="row reset-row eip-pt-10">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <EIPAutoComplete ShowTextValueField='N' WaterMarkText="From" class="business-group"
                TextField="description" ValueField="value"
                [dataSource]='createdByList' setId="ddFromId" (valueChange)='changeCreatedBy($event)'
                [IsCascading]='true'>
              </EIPAutoComplete>
          </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
          <EIPAutoComplete ShowTextValueField='N' WaterMarkText="To" class="business-group"
            TextField="description" ValueField="value"
            [dataSource]='authorizedByList' setId="ddToId" (valueChange)='changeAuthorizedBy($event)'
            [IsCascading]='true'>
          </EIPAutoComplete>
      </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-12">
            <EIPAutoComplete ShowTextValueField='N' WaterMarkText="Status" class="business-group"
              TextField="description" ValueField="value"
              [dataSource]='statusList' setId="ddStatusId" (valueChange)='changeStatusBy($event)'
              [IsCascading]='true'>
            </EIPAutoComplete>
        </div>

  </div>
  <div class="eip-pl-20 eip-pr-20 eip-pb-20">
    <EIPGeneralCart [CartParameters]="cartRequest" (OnCartSubmit)='getSelectedCartItems($event)'
      (OnClick)='setCartParams()'>
    </EIPGeneralCart>
  </div>
</div>